<div class="header">
    <div class="navigation-tabs">
        <span
            class="navigation-tabs__tab"
            [ngClass]="{ 'navigation-tabs__tab--active': selectedTab === 'reports' }"
            (click)="onTabClick('reports')"
        >
            {{'aumico_annual_report_complementary_report_create_report' | i18next }}
        </span>
        <span
            *ngIf="updatedComplementaryReports.length !== 0"
            class="navigation-tabs__tab"
            [ngClass]="{ 'navigation-tabs__tab--active': selectedTab === 'organize' }"
            (click)="onTabClick('organize')"
        >
            {{'aumico_annual_report_complementary_report_organize_report' | i18next }}
        </span>
    </div>
    <ham-button
        *ngIf="selectedTab === 'reports'"
        icon="assets/hamIcons/file-circle-plus-outline.svg"
        type="submit"
        [size]="'sm'"
        (buttonClick)="openAddNewReportDialog = true"
    >
        {{'aumico_annual_report_complementary_reports_add_report_button' | i18next }}
    </ham-button>
</div>
<div class="complementary-container">
    <ng-container *ngIf="selectedTab === 'organize'">
        <div class="sort-container" cdkDropListGroup>
            <div
                class="sort-container__box"
                cdkDropList
                id="startList"
                [cdkDropListData]="reportsAtTheStart"
                (cdkDropListDropped)="drop($event)"
            >
                <div class="sort-container__box-title">
                    <p>{{'aumico_annual_report_complementary_reports_at_the_start' | i18next }}</p>
                </div>
                <div
                    class="sort-container__inner-box"
                    *ngFor="let item of reportsAtTheStart"
                    cdkDrag
                    cdkDragPreviewContainer="parent"
                >
                    <span class="ham-icon drag-icon">
                        <i class="dots-grid-icon"></i>
                    </span>
                    <span class="report-title"> {{ item?.name }}</span>
                </div>
                <p *ngIf="!reportsAtTheStart || reportsAtTheStart.length === 0" class="empty-list-message">
                    {{'aumico_annual_report_complementary_reports_drag_here' | i18next }}
                </p>
            </div>

            <div
                class="sort-container__box"
                cdkDropList
                id="endList"
                [cdkDropListData]="reportsAtTheEnd"
                (cdkDropListDropped)="drop($event)"
            >
                <div class="sort-container__box-title">
                    <p>{{'aumico_annual_report_complementary_reports_at_the_end' | i18next }}</p>
                </div>
                <div
                    class="sort-container__inner-box"
                    *ngFor="let item of reportsAtTheEnd"
                    cdkDrag
                    cdkDragPreviewContainer="parent"
                >
                    <span class="ham-icon drag-icon">
                        <i class="dots-grid-icon"></i>
                    </span>
                    <span class="report-title"> {{ item?.name }}</span>
                </div>
                <p *ngIf="!reportsAtTheEnd || reportsAtTheEnd.length === 0" class="empty-list-message">
                    {{'aumico_annual_report_complementary_reports_drag_here' | i18next }}
                </p>
            </div>

            <div
                class="sort-container__box"
                cdkDropList
                id="appendixList"
                [cdkDropListData]="reportsAsAppendix"
                (cdkDropListDropped)="drop($event)"
            >
                <div class="sort-container__box-title">
                    <p>{{'aumico_annual_report_complementary_reports_as_appendix' | i18next }}</p>
                </div>
                <div
                    class="sort-container__inner-box"
                    *ngFor="let item of reportsAsAppendix"
                    cdkDrag
                    cdkDragPreviewContainer="parent"
                >
                    <span class="ham-icon drag-icon">
                        <i class="dots-grid-icon"></i>
                    </span>
                    <span class="report-title"> {{ item?.name }}</span>
                </div>
                <p *ngIf="!reportsAsAppendix || reportsAsAppendix.length === 0" class="empty-list-message">
                    {{'aumico_annual_report_complementary_reports_drag_here' | i18next }}
                </p>
            </div>
        </div>
    </ng-container>

    <div class="reports-container" [ngClass]="{ 'reports-container--hidden': selectedTab === 'organize' }">
        <ham-accordion *ngFor="let complementaryReport of updatedComplementaryReports; let reportIndex = index">
            <ham-accordion-item #accordion [isOpened]="accordion.expanded" backgroundColor="#fff">
                <div class="accordion-header" accordion-header>
                    <div class="accordion-header-title" #accordionElement>
                        <complementary-report-title
                            [placeholder]="'aumico_annual_report_complementary_reports_report_title' | i18next"
                            stopPropagation
                            [initialValue]="complementaryReport.title"
                            [displayLabel]="accordion.expanded"
                            [formStatus]="complementaryReportsFormsStatuses[reportIndex]"
                            (valueChange)="onTitleChange($event, reportIndex)"
                            (formStatusChange)="onFormStatusChange($event, reportIndex)"
                        ></complementary-report-title>
                    </div>
                    <span class="accordion-icon">
                        <span
                            *ngIf="!accordion.expanded"
                            class="chevron-down"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-down.svg"
                            [variant]="'transparent'"
                            [size]="'regular'"
                            (click)="accordion.onToggle()"
                        ></span>
                        <span
                            *ngIf="accordion.expanded"
                            hamIconShapes
                            class="chevron-up-outline"
                            icon="assets/hamIcons/chevron-up-outline.svg"
                            [variant]="'transparent'"
                            [size]="'regular'"
                            (click)="accordion.onToggle()"
                        ></span>
                    </span>
                </div>

                <div accordion-body>
                    <lib-complementary-reports-component
                        [updatedComplementaryReports]="updatedComplementaryReports"
                        [complementaryReport]="complementaryReport"
                        [reportIndex]="reportIndex"
                        [reportTitle]="complementaryReport.title"
                        [isUploading]="isReportUploading(reportIndex)"
                        [formStatus]="complementaryReportsFormsStatuses[reportIndex]"
                        (deleteReportClicked)="onDeleteReportClicked(reportIndex, complementaryReport)"
                        (complementaryReportChanged)="onComplementaryReportChanged($event, reportIndex)"
                        (formStatusChanged)="onComplementaryReportStatusChanged($event, reportIndex)"
                        [previewStatus]="complementaryReportPreviews[complementaryReport.fileId || '']?.previewStatus"
                        [previewUrl]="complementaryReportPreviews[complementaryReport.fileId || '']?.previewUrl"
                        (previewRequested)="onPreviewRequested($event)"
                        (previewClosed)="onPreviewClosed($event)"
                        (openFile)="onOpenFile($event)"
                        (downloadFile)="onDownloadFile($event)"
                        (printComplementaryReport)="onPrintComplementaryReportClicked($event)"
                    ></lib-complementary-reports-component>
                </div>
            </ham-accordion-item>
        </ham-accordion>
        <div class="empty-state-wrapper" *ngIf="updatedComplementaryReports.length === 0">
            <div class="empty-state">
                <span
                    class="file-circle-plus-outline-wrapper"
                    hamIconShapes
                    icon="assets/hamIcons/file-circle-plus-outline.svg"
                    [size]="'50px'"
                >
                </span>
                <div class="text1">{{ 'aumico_annual_report_complementary_reports_empty_state_text1' | i18next }}</div>
                <div class="text2">{{ 'aumico_annual_report_complementary_reports_empty_state_text2' | i18next }}</div>
                <ham-button
                    type="submit"
                    icon="assets/hamIcons/plus-outline.svg"
                    (buttonClick)="openAddNewReportDialog = true"
                >
                    {{'aumico_annual_report_complementary_reports_add_report_button' | i18next }}
                </ham-button>
                <div
                    class="text3"
                    [innerHTML]="'aumico_annual_report_complementary_reports_empty_state_text3' | i18next"
                ></div>
            </div>
        </div>
    </div>
</div>

<ham-modal
    *ngIf="openAddNewReportDialog"
    [title]="'aumico_annual_report_complementary_reports_new_title' | i18next"
    (cancel)="openAddNewReportDialog = false"
    [size]="'lg'"
>
    <ul class="selection-list">
        <li (click)="onNewReportFromTemplate()" class="selection-item">
            {{'aumico_annual_report_complementary_reports_add_from_template' | i18next }}
        </li>
        <li (click)="onNewReportFromScratch()" class="selection-item">
            {{'aumico_annual_report_complementary_reports_add_blank_report' | i18next }}
        </li>
        <li *ngIf="organizationHasCpmmActive" (click)="onUploadPDF()" class="selection-item">
            {{'aumico_annual_report_complementary_reports_upload_PDF' | i18next }}
        </li>
        <li *ngIf="!organizationHasCpmmActive" class="selection-item deactivated">
            <span> {{'aumico_annual_report_complementary_reports_upload_PDF' | i18next }}</span>
            <span class="ham-icon icon">
                <i class="lock-icon"></i>
            </span>
        </li>
    </ul>
</ham-modal>

<!-- Page-level Template Picker Modal -->
<ham-modal
    *ngIf="openTemplatePickerDialog"
    [title]="'aumico_annual_report_complementary_reports_select_template' | i18next"
    [size]="'sm'"
    [showCancelButton]="true"
    [cancelText]="'aumico_annual_report_complementary_reports_template_cancel' | i18next"
    [saveText]="'aumico_company_assignee_change_confirmation_dialog_save_button' | i18next"
    (cancel)="onTemplatePickerCancel()"
    (save)="onTemplatePickerSave()"
>
    <lib-text-snippets-list-dialog-component
        (insertTextSnippetClicked)="onTemplateRowClicked($event)"
    ></lib-text-snippets-list-dialog-component>
</ham-modal>

<!-- Page-level Upload PDF Modal -->
<ham-modal
    *ngIf="showUploadModal"
    [saveText]="'aumico_company_assignee_change_confirmation_dialog_save_button' | i18next"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    [showCloseIcon]="true"
    [size]="'sm'"
    (cancel)="onPageCancelUpload()"
    (save)="onPageFileUploaded()"
    tabindex="0"
    (keydown.enter)="onPageFileUploaded()"
>
    <upload-document [acceptedExtensions]="acceptedExtensions" (fileUploaded)="onPageNewFileUploaded($event)">
    </upload-document>
</ham-modal>
<ham-modal
    *ngIf="showTitleInputModal"
    class="title-input-modal"
    hideHeader="true"
    [showCancelButton]="true"
    [cancelText]="'aumico_button_cancel' | i18next"
    [saveText]="'aumico_button_save' | i18next"
    (cancel)="onTitleModalCancel()"
    (save)="onTitleModalConfirm()"
    [disabled]="!control.value?.trim()?.length || control.invalid"
>
    <label [class.title-error]="(control.errors?.['required'] || control.errors?.['squareBrackets']) && control.touched">
        {{ 'aumico_annual_report_complementary_report_name' | i18next }}
        <span style="color: var(--red-600, #e02424)">*</span>
    </label>
    <input
        hamInput
        [formControl]="control"
        [placeholder]="'aumico_annual_report_complementary_reports_report_title' | i18next"
    />
    <span *ngIf="control.errors?.['squareBrackets']" style="color: var(--red-600, #e02424); font-size: 12px;">
        {{ 'aumico_annual_report_complementary_reports_title_no_brackets' | i18next }}
    </span>
</ham-modal>
